import { JetView } from "webix-jet";
import { checkedIcon, notCheckedIcon } from "../../helpers/icons";
import { userAvatar } from "../../helpers/templates";

export default class UsersView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		const form = {
			view: "form",
			rows: [
				{
					rows: [
						{
							view: "template",
							localId: "title",
							borderless: true,
							height: 25,
							css: "webix_um_details_title",
							template: "#name#",
							data: { name: "" },
						},
						{
							cols: [
								{
									view: "template",
									localId: "number",
									borderless: true,
									height: 40,
									css: "webix_um_details_title_description",
									template: v => {
										const number = v.number ? v.number : 0;
										let descr = !number
											? _("No members")
											: `${_("Members assigned")} (${number})`;
										return `<div class="webix_um_details_title_description">${descr}</div>`;
									},
									data: { name: "" },
								},
								{
									rows: [
										{
											view: "toggle",
											localId: "toggle",
											offLabel: _("Modify"),
											onLabel: _("Done"),
											width: 160,
											on: {
												onChange: v => this.ToggleVisible(v),
											},
										},
										{},
									],
								},
							],
						},
					],
				},
			],
		};

		const table = {
			view: "datatable",
			localId: "users",
			css: "webix_um_details_table",
			rowHeight: webix.skin.$active.rowHeight + 10,
			columns: [
				{
					id: "selected",
					hidden: true,
					header: "",
					width: 45,
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
					template: obj => {
						return obj.selected ? checkedIcon : notCheckedIcon;
					},
				},
				{
					id: "name",
					header: {
						content: "textFilter",
						placeholder: _("Search"),
					},
					template: obj => userAvatar(obj) + obj.name,
					fillspace: 2,
					cssFormat: (_, obj) => (obj.selected ? "webix_um_row_select" : ""),
				},
			],
			checkboxRefresh: true,
			on: {
				onItemClick: id => this.Toggle(id.row * 1),
			},
		};

		return { type: "clean", rows: [form, table] };
	}

	urlChange() {
		this.ID = this.getParam("id", true) * 1;
		if (this.ID) this.GetData();
	}

	GetData() {
		const local = this.app.getService("local");
		this.ShowAll = false;
		this.$$("users").registerFilter(
			this.$$("toggle"),
			{
				compare(_v1, _v2, obj) {
					return obj.selected;
				},
			},
			{
				getValue: a => (a.getValue() ? "" : true),
			}
		);

		return Promise.all([local.roles(), local.users()]).then(data => {
			this.Role = webix.copy(data[0].getItem(this.ID));
			this.Role.number = 0;
			const users = data[1].serialize().map(({ id, avatar, name, roles }) => {
				let selected = roles && roles.indexOf(this.ID) !== -1;
				if (selected) this.Role.number++;
				return {
					id,
					avatar,
					name,
					selected,
				};
			});
			this.$$("users").parse(users);
			this.$$("title").setValues(this.Role);
			this.ShowNumber();
			this.Filter();
		});
	}

	ShowNumber() {
		this.$$("number").setValues(this.Role);
	}

	Save(id) {
		const data = this.app.getService("local").users(true);
		let user = data.getItem(id);
		if (this.$$("users").getItem(id).selected) {
			this.Role.number++;
			if (!user.roles) user.roles = [];
			if (user.roles.indexOf(this.ID) < 0)
				user.roles[user.roles.length] = this.ID;
		} else if (user.roles && user.roles.indexOf(this.ID) >= 0) {
			user.roles.splice(user.roles.indexOf(this.ID), 1);
			this.Role.number--;
		}
		this.ShowNumber();
		this.app.getService("operations").updateUser(id, user);
	}

	ToggleVisible() {
		this.ShowAll = !this.ShowAll;
		if (this.ShowAll) this.$$("users").showColumn("selected");
		else this.$$("users").hideColumn("selected");

		this.Filter();
	}

	Toggle(id) {
		if (!this.ShowAll) return;
		const item = this.$$("users").getItem(id);
		this.$$("users").updateItem(id, { selected: !item.selected });
		this.Save(id);
	}

	Filter() {
		this.$$("users").filterByAll();
		this.$$("users").sort((a, b) =>
			a.selected == b.selected
				? a.name > b.name
					? 1
					: -1
				: a.selected
				? -1
				: 1
		);
	}
}
